import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { map } from "rxjs/operators";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  constructor(private http: HttpClient) {}

  getEmailTemplate(data: any): Observable<string> {
    return this.http
      .get("assets/email-template/email-template.html", { responseType: "text" })
      .pipe(
        map((template) => {
          return template
            .replace(/{{subject}}/g, data.subject)
            .replace(/{{recipientName}}/g, data.recipientName)
            .replace(/{{messageDetail}}/g, data.messageDetail)
            .replace(/{{inquirerName}}/g, data.inquirerName)
            .replace(/{{inquirerEmail}}/g, data.inquirerEmail)
            .replace(/{{inquirerPhone}}/g, data.inquirerPhone)
            .replace(/{{developmentName}}/g, data.developmentName)
            .replace(/{{projectId}}/g, data.projectId)
            .replace(/{{projectDescription}}/g, data.projectDescription)
            .replace(/{{projectManager}}/g, data.projectManager)
            .replace(/{{inquiryType}}/g, data.inquiryType);
        }),
      );
  }

  sendEmail(emailData: any): Observable<any> {
    const apiUrl = environment.apiUrl + "/api/sendEmail";

    const payload = {
      subject: emailData.subject, // SETTING SUBJECT HERE
      htmlBody: emailData.htmlBody,
    };

    //return this.http.post(proxyUrl + apiUrl, payload);

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
    });

    return this.http.post(apiUrl, payload, { headers });
  }
}
